/*
* Used on the homepage to filter courses based on course categories
*/

(function($){
	var courses;
	$(document).ready(function() {
		$('.courses_heading li').on('click', function(event) {
			event.preventDefault();
			filterCourses($(this).data('id'));
		});
		courses = $('.recommended_container');
	});



	/*
	* Filters courses displayed based on category title
	*/
	var filterCourses = function(categoryId){
		courses.hide();
		courses.each(function(){
			var course = $(this);
			var data = course.data('course');
			var categories = data.categories;
			if(categoryId === -1 || containsId(categories, categoryId)){
				course.show();
			}
		});
	};

	var containsId = function(array, id){
		for (var i = array.length - 1; i >= 0; i--) {
			if(array[i].id === id){
				return true;
			}
		};
		return false;
	}

})(jQuery);